import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { SFWBuilderContext } from '../../../../Context/BuilderContext';



import { RetailerContext } from '../../../../Context/Retailer.Context';
import { RoutingContext } from '../../../../Context/Routing.Context';
import TheButton from '../../UI/TheButton/TheButton';
import { LanguageContext } from '../../../../Context/Language.Context';
import { logEvent } from '../../../../Utils/google-analytics';
import { RetailerLogo } from '../../../../components/Logo/RetalierLogo';
import styles from "./Cards.module.css";
import TheIcon from '../../UI/TheIcon/TheIcon';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { NormalizeSlugs } from '../../../../Utils/helper-functions';
import { useRetailerHook, useLanguageHook, useRoutingHook, useSFWBuilderHook } from '../../../../Hooks/use-context-hooks';


const ProductCard = ({ product }) => {
    const { setIsRoutingState, setIsFlashMessageState } = useRoutingHook();
    const { addItemToBuilderList, removeItemFromBuilderList, builderListItems } = useSFWBuilderHook()
    const { isHomeDepotApp } = useRetailerHook()
    const { language, translatedText } = useLanguageHook();
    const { title, store, image, availability, subtitle,  categoryEN } = product;
    console.log(product)
    const normalizedCategoryName = categoryEN && NormalizeSlugs(categoryEN)
    const productURL = `${isHomeDepotApp.isHomeDepotPrefix}/appliances/${normalizedCategoryName}/${title}`;
    // const productURL = `/appliances/${normalizedCategoryName}/${title}`;
    const redirect = useNavigate();





    // HANDLE FLASH MESSAGES 
    //---------------------//
    const handleAddToList = () => {
        const productAlreadyInList = builderListItems.find(item => item._id === product._id);
        let message;

        if (productAlreadyInList) {
            removeItemFromBuilderList(product);
            message = language === "EN" ? `${product.title} removed from list` : `Product ${product.title} retiré de la liste`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'subtracted',
                styleName: 'subtracted'
            }))

            logEvent('User Interaction', 'Remove_From_List', `Product Title: ${product.title}`);
        } else {
            addItemToBuilderList(product);
            message = language === "EN" ? `${product.title} added to list` : `Product ${product.title} ajouté à la liste`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'checkmark',
                styleName: 'checkmark'
            }))
            logEvent('User Interaction', 'Add_To_List', { productTitle: product.title });
        }

    }

    const handleDetailsClick = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isNavLinkedClicked: true,
            isBuilderDropdownOpen: false,
            isMobileBuilderDropdownOpen: false,
        }))

    }

    return (
        <div className={styles.productCardContainer}>
            <div className={styles.retailerLogo}>
                {
                    product && product.store === 'HD'
                        ? <RetailerLogo store={store} />
                        : null
                }
            </div>

            <div className={styles.productCardImageBox}>


                <NavLink
                    onClick={handleDetailsClick}
                    to={productURL}
                // to={`${isHomeDepotApp.isHomeDepotPrefix}/product-details/${product?.title}`}
                >
                    <img src={`${process.env.REACT_APP_AWS_URL}/` + image} alt={title} className={styles.productImage} />
                </NavLink>
                {/* </div> */}
            </div>
            <div className={styles.productBodyWrapper}>
                <div className={styles.productCardTextBox}>
                    {
                        product && product.availability !== "Available"
                            ? <span className={styles.availabilityText}>{availability}</span>
                            : <span className={styles.availabilityTextHidden}>{availability}</span>
                    }
                    <h2 className={styles.productTitle}>
                        {title}
                    </h2>
                    <p className={styles.productSubtitle}>
                        <span className={styles.clampedSubtitle}>{subtitle}</span>
                        {subtitle.length > 500 && '... '}
                    </p>
                </div>

                <div className={styles.productCardButtonBox}>
                    <span onClick={handleAddToList}>
                        <TheButton
                            animated='true'

                            buttonIcon="true"

                            styleName={builderListItems.some(item => item._id === product._id) ? "blackIconButton" : "redIconButton"}
                            iconName={builderListItems.some(item => item._id === product._id) ? "subtracted" : "add"}

                        >
                            {
                                builderListItems.some(item => item._id === product._id) ?
                                    <span>
                                        {translatedText.ctaRemoveFromList}
                                    </span>
                                    :
                                    <span>
                                        {translatedText.ctaAddToList}
                                    </span>
                            }

                        </TheButton></span>

                    <div className={styles.buttonBox} onClick={handleDetailsClick}>
                        <TheButton
                            iconName="forward"
                            buttonIcon="true"
                            styleName="whiteIconButton"
                            animated="true"
                            link={productURL}
                            // link={`${isHomeDepotApp.isHomeDepotPrefix}/product-details/${product?.title}`}
                            linkText={translatedText.ctaDetails}
                        // linkText={translatedText.ctaSeeDetails}
                        // buttonTracking
                        // interactionName={`see_details_${product?.title}`}
                        >
                            {/* <TheIcon name={`scrollRight`}/> */}
                        </TheButton>
                    </div>
                    {/* <NavLink to={`/product-details/${product.title}`}>
                        <Button
                            animated="true"

                            styleName='white'
                            buttonClassType='seeDetailsBtn'
                            
                            onClick={handleDetailsClick}
                        >

                            {translatedText.ctaSeeDetails} <Icon name="forward-arrow" />

                        </Button>  </NavLink> */}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;